export default __webpack_public_path__ + "static/media/Secondary_No_Slogan.6c87a747.png";